import React from 'react'
import { Control, Controller, UseFormSetValue } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { Select } from 'ui/fields'
import useGetLevelList from '../../../hooks/useGetLevelList'
import { useEffect } from 'react'
import { Inputs } from './forms/Forms'
interface Props {
   index: number
   control: Control<Inputs, any>
   errors: any
   dirtyFields: any
   loyaltyplanId?: string
   setValue: UseFormSetValue<any>
   isCreate?: boolean,
   defaultLevel?: string
}
const LevelIdField = (props: Props) => {
   const { index, control, errors, dirtyFields, loyaltyplanId, isCreate, setValue, defaultLevel } = props
   const intl = useIntl()
   const { data: levels, isLoading: levelStatus } = useGetLevelList(
      {
         loyaltyPlanIds: loyaltyplanId ? parseInt(loyaltyplanId) : undefined,
      },
      isCreate,
      defaultLevel
   )
   useEffect(() => {
      if (levels && levels.totalSize === 1 && levels.items.length === 1) {
         setValue(`loyaltyPlans.${index}.level`, levels.items[0].name)
      }
   }, [levels, control, index, setValue])

   return (
      <React.Fragment key={index}>
         <Controller
            name={`loyaltyPlans.${index}.level`}
            control={control}
            rules={{
               required: intl.formatMessage({ id: 'partner.errors.levelId' }),
               validate: (value: string) => {
                  return value.length ? true : intl.formatMessage({ id: 'partner.errors.levelId' })
               },
            }}
            render={({ field: { value, onChange } }) => (
               <Select
                  boldLabel={false}
                  disabled={levelStatus || !isCreate}
                  label={intl.formatMessage({ id: 'partner.form.level' })}
                  value={value || ''}
                  onChange={(i: string) => onChange(i)}
                  error={errors?.loyaltyPlans?.[index]?.level?.message}
                  showErrorText={true}
                  className="mb-4 w-full text-gray-700"
                  isTouched={dirtyFields.loyaltyPlans?.[index]?.level}
               >
                  <Select.Option value="">Seleccionar</Select.Option>
                  {levels &&
                     levels.items.map((plan) => (
                        <Select.Option key={plan.id} value={plan.name}>
                           {plan.name}
                        </Select.Option>
                     ))}
               </Select>
            )}
         />
      </React.Fragment>
   )
}

export default LevelIdField
